import { 
  BalanceZoneStoreModel,
  CompanyStoreModel,
  getAppConfigurationValue } from '../../../../redux'
import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import AxiosInstance from '../../../http-config'
import { Capacity } from '../../model/Capacity'
import { EnumLockCapacity } from '../../model'
import { EnumServicio, EnumTipoNaturaleza, EnumTipoProductoCapacidad } from '../../../oData/enums'
import { Capacidad } from '../../../oData/model'
import { CapacityRequest } from '../../../oData/requests'
import moment from 'moment'

export const getCapacityByID = async (id: number): Promise<Capacity> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Capacities?id=${id}`).then(response => {
    return response.data
  })
}

export const postCapacityChangeLock = async (
  id: number,
  lockStatus: EnumLockCapacity
): Promise<Capacity[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Capacities/${id}/ChangeLockStatus`, {
    lockStatus
  }).then(response => {
    return response.data
  })
}

export const getCapacitiesActivas = async (
  startDate: Date,
  endDate: Date,
  balanceZone?: BalanceZoneStoreModel | undefined,
  company?: CompanyStoreModel | undefined
): Promise<Array<Capacity>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
  const initRange = moment(startDate).format('YYYY-MM-DD')
  const endRange = moment(endDate).format('YYYY-MM-DD')

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Capacities/GetCapacities?startDate=${initRange}&endDate=${endRange}&companyId=${company?.id}&balanceZoneId=${balanceZone?.id}`
  ).then(response => {
    return response.data
  })
}

export const getCapacities = async (
  startDate: Date,
  endDate: Date,
  balanceZone?: BalanceZoneStoreModel | undefined,
  company?: CompanyStoreModel | undefined,
  service?: string,
  logisticElement?: number,
  duration?: string,
  nature?: string
): Promise<Array<Capacity>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  let filter = ``
  if (service) {
    filter += `&service=${EnumServicio[service as keyof typeof EnumServicio]}`
  }
  if (logisticElement) {
    filter += `&idLogisticElement=${logisticElement}`
  }
  if (duration) {
    filter += `&productCapacityType=${EnumTipoProductoCapacidad[duration as keyof typeof EnumTipoProductoCapacidad]}`
  }
  if (nature) {
    filter += `&natureType${EnumTipoNaturaleza[nature as keyof typeof EnumTipoNaturaleza]}`
  }

  const initRange = moment(startDate).format('YYYY-MM-DD')
  const endRange = moment(endDate).format('YYYY-MM-DD')

  return await AxiosInstance.get(
        `${apiSuffixUrl}/api/Capacities/GetCapacities?startDate=${initRange}&endDate=${endRange}&companyId=${company?.id}&balanceZoneId=${balanceZone?.id}` + filter
  ).then(response => {
    return response.data
  })
}

export const getCapacitiesForAllocations = async (
  startDate: Date,
  endDate: Date,
  balanceZone?: BalanceZoneStoreModel | undefined,
  company?: CompanyStoreModel | undefined
): Promise<Array<Capacidad>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  const initRange = moment(startDate).format('YYYY-MM-DD')
  const endRange = moment(endDate).format('YYYY-MM-DD')

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Capacities/ForAllocations?startDate=${initRange}&endDate=${endRange}&companyId=${company?.id}&balanceZoneId=${balanceZone?.id}`
  ).then(response => {
    return response.data
  })
}

export const postCapacity = async (request: CapacityRequest): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Capacities`, request).then(response => {
    return response.data
  })
}

export const patchCapacity = async (request: CapacityRequest): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
  
  return await AxiosInstance.patch(`${apiSuffixUrl}/api/Capacities/${request.id}`, request).then(
    response => {
      return response.data
    }
  )
}
